import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../Note/index.scss";
import { getDynamicLabel } from "helper/common";

const PaymentNote = ({
  dynamic_label,
  size,
  alert_type,
  trigger,
  custom_styles,
  contents_payment,
  show,
  selectedData,
  payment_id,
  terms_and_condition
}) => {
  const recursive = useSelector((state) => state?.recursive);
  const paymentInfo = useSelector((state) => state.paymentReducer);

  const isDisabledPaymentAmount = () => {
    if (
      selectedData?.payment_ids &&
      Array.isArray(selectedData?.payment_ids) &&
      selectedData?.payment_ids?.length
    ) {
      return (
        selectedData?.payment_ids?.find((item) => item?.name === payment_id) ||
        false
      ).status;
    }
    return false;
  };

  let examinedLabel = payment_id ? isDisabledPaymentAmount() : null;

  const paymentLabel = examinedLabel ? eval(dynamic_label) : null;

  const dynamicLabel = getDynamicLabel(dynamic_label, {
    paymentInfo,
    recursive,
    examinedLabel,
  });

  return show && !eval(show) ? null : (
    <>
      <div className={size}>
        <div className={`note_container_${alert_type} ${custom_styles}`}>
          <p className={alert_type}>{trigger}</p>
          {paymentLabel || dynamicLabel}
        </div>
      </div>
      {terms_and_condition && contents_payment?.length > 0 && (
        <div className="p-2 pb-0 mt-2 fw-bold text-black">
          {paymentLabel}
          <ol className="list-group list-group-numbered p-2">
            {contents_payment?.map((item, index) => (
              <li key={index} className="list-group-item border-0 fw-normal">
                {item}
              </li>
            ))}
          </ol>
        </div>
      )}
    </>
  );
};

PaymentNote.propTypes = {
  dynamic_label: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  alert_type: PropTypes.string.isRequired,
  trigger: PropTypes.string.isRequired,
  custom_styles: PropTypes.string,
  show: PropTypes.string,
  selectedData: PropTypes.object,
  payment_id: PropTypes.string,
};

PaymentNote.defaultProps = {
  custom_styles: "",
  show: "",
  selectedData: {},
};

export default PaymentNote;
